import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-10 bg-background-50">
      <div className="max-w-screen-lg mx-auto">
        <div className="relative rounded-2xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Artistic%20fashion%20and%20lifestyle%20collage%20with%20soft%20textured%20overlay%20warm%20cream%20and%20beige%20palette%20scattered%20clothing%20accessories%20and%20shopping%20elements%20blending%20into%20abstract%20composition%20soft%20diffused%20lighting%20dreamy%20atmospheric%20editorial%20magazine%20quality%20elegant%20gallery%20wall%20aesthetic&width=1200&height=500&seq=cta-banner-v2&orientation=landscape"
            alt="GTBuy Sheet shopping experience"
            className="w-full h-64 md:h-80 object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/40 to-transparent flex items-center">
            <div className="px-6 md:px-14">
              <h2 className="text-xl md:text-3xl font-heading font-semibold text-background-50 leading-tight max-w-md">
                Ready to <span className="italic font-normal">shop smarter</span> with GTBuy Sheet?
              </h2>
              <div className="mt-5 flex flex-col sm:flex-row gap-3">
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="px-6 py-3 text-sm font-semibold bg-background-50 text-primary-700 rounded-full hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer text-center"
                >
                  buy it now
                  <i className="ri-arrow-right-up-line ml-2 text-sm"></i>
                </a>
                <Link
                  to="/article/gtbuy-spreadsheet-guide"
                  className="px-6 py-3 text-sm font-medium text-background-50 border border-background-50/40 rounded-full hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer text-center"
                >
                  Learn More
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}